import CacheStorage from "../storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";
import UtilityHelper from "../utilities/UtilityHelper";
import { CompanyCodeDetails } from "../../model/app_config/AppConfigModel";

export default class AppTheme {
  // SHOULB BE SAME IN CSS/STYLE.SCSS
  static primary: string = "#000000";
  static themeFont: string = "#ffffff";
  static label: string = "#000000";
  static subLabel: string = "#747474";
  static bg: string = "#ffffff";
  static textField: string = "#B5B7B9";
  static validation: string = "#FF0000";
  static black: string = "#000000";
  static white: string = "#ffffff";
  static grey: string = "#F2F2F2";
  static red: string = "#E83F4B";
  static green3: string = "#00A990";

  static primaryDefault: string = "#000000";
  static themeFontDefault: string = "#ffffff";
  static labelDefault: string = "#000000";
  static subLabelDefault: string = "#747474";
  static bgDefault: string = "#ffffff";

  /* constructor() {
        AppThemeColours.init();
    } */

  static init() {
    this.applyStyleConst();
    this.applyStyleTheme();
  }

  static applyStyleConst = () => {
    const stored: any = CacheStorage.getValue(StorageKeys.web_app_config);
    if (UtilityHelper.isNotEmpty(stored)) {
      const companyCodeDetails: CompanyCodeDetails = JSON.parse(stored);
      this.primary = companyCodeDetails.company_theme_color ?? "#000000";
      this.themeFont = companyCodeDetails.company_theme_font_color ?? "#ffffff";
      this.label = companyCodeDetails.company_theme_label_color ?? "#000000";
      this.subLabel =
        companyCodeDetails.company_theme_sub_label_color ?? "#747474";
      this.bg = companyCodeDetails.company_theme_background_color ?? "#ffffff";
    }
  };

  static applyStyleTheme = () => {
    const stored: any = CacheStorage.getValue(StorageKeys.web_app_config);
    if (UtilityHelper.isNotEmpty(stored)) {
      this.applyStyleConst();

      const style = document.createElement("style");
      style.type = "text/css";
      style.id = "my-inline-style"; // optional, useful for later reference

      // Add CSS rules as a string
      let innerHTML: string = `
                :root {
                  --color-primary: ${this.primary};
                  --color-theme-font: ${this.themeFont} ;
                  --color-theme-label:  ${this.label};
                  --color-theme-sublabel: ${this.subLabel} ;
                  --color-theme-bg: ${this.bg};
                }
                  
                .color-primary { color: ${this.primary} !important; }
                .color-theme-font { color: ${this.themeFont} !important;}
                .color-theme-label { color: ${this.label} !important; }
                .color-theme-sublabel { color: ${this.subLabel} !important; }
                .color-theme-bg { color: ${this.bg} !important; }

                .bgcolor-primary { background-color: ${this.primary} !important; }
                .bgcolor-theme-font { background-color: ${this.themeFont} !important;}
                .bgcolor-theme-label { background-color: ${this.label} !important; }
                .bgcolor-theme-sublabel { background-color: ${this.subLabel} !important; }
                .bgcolor-theme-bg { background-color: ${this.bg} !important; }

                html{  background-color: ${this.primary} !important;}
                `;

      if (UtilityHelper.checkStandAlone()) {
        innerHTML += `.app-wrapper {height: 100dvh !important; }`;
      }

      style.innerHTML = innerHTML;
      document.head.appendChild(style);

      // CHANGE MOBILE BROWSER COLOR
      let meta = document.querySelector(
        'meta[name="theme-color"]'
      ) as HTMLMetaElement | null;

      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "theme-color";
        document.head.appendChild(meta);
      }

      meta.content = this.primary;

      // Optional: Clean up the style tag when the component unmounts
      return () => {
        const existing = document.getElementById("my-inline-style");
        if (existing) {
          existing.remove();
        }
      };
    }
  };
}
